
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schedule/event3",
      function () {
        return require("private-next-pages/schedule/event3/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schedule/event3"])
      });
    }
  